import { useQuery } from '@tanstack/react-query'
import { api } from '~/apiClient'
import { useUser } from '~/features/auth/api/useUser'

type DepositConfig = {
    depositId: string
    customerToken: string
}

export const useDepositConfig = () => {
    const { data: user } = useUser()
    return useQuery<DepositConfig>({
        queryKey: ['moonpay.deposit.config'],
        queryFn: () => api.post<DepositConfig>('/api/moonpay/deposit/initiate/'),
        enabled: user?.is_auth,
    })
}
